import { useState } from 'react';
import apiClient from '../utils/api';

interface SendConfirmationEmailData {
  email: string;
}

interface ConfirmEmailData {
  token: string;
  password: string;
}

interface EmailConfirmationResponse {
  message: string;
  // Add other fields your API returns
}

export const useEmailConfirmation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendConfirmationEmail = async (data: SendConfirmationEmailData): Promise<EmailConfirmationResponse | null> => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiClient.post('/users/send-confirmation', data);
      return response.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to send confirmation email. Please try again.';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const confirmEmailAndSetPassword = async (data: ConfirmEmailData): Promise<EmailConfirmationResponse | null> => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiClient.post(`/users/confirm-email/${data.token}`, { 
        password: data.password 
      });
      return response.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Email confirmation failed. Please try again.';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    sendConfirmationEmail,
    confirmEmailAndSetPassword,
    loading,
    error
  };
};
